import wam from '@tcc/wam';

export function getUserData() {
  try {
    return wam.getUserData();
  } catch {
    return null;
  }
}

export function reAuthenticate() {
  return wam.reAuthenticate();
}

export function logout() {
  wam.logout();
  sessionStorage.clear();
  localStorage.clear();
}
